import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_CATEGORY_SUCCESS = "SHOP:GET_PRODUCT_CATEGORY_SUCCESS";

export const getProductCategorySuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: any
) => ({
  type: GET_PRODUCT_CATEGORY_SUCCESS as typeof GET_PRODUCT_CATEGORY_SUCCESS,
  organization,
  id,
  data,
});

export type GetProductCategorySuccessAction = ReturnType<
  typeof getProductCategorySuccessAction
>;
